import React from 'react';
import './RichEditor.css';

interface RichEditorProps {
  content: string;
  onChange: (content: string) => void;
  placeholder?: string;
}

const RichEditor: React.FC<RichEditorProps> = ({ content, onChange, placeholder = "Start writing..." }) => {
  // Temporary simple textarea while we fix React version conflicts
  return (
    <div className="rich-editor">
      <div className="rich-editor-toolbar">
        <p>Rich Editor temporarily disabled due to React version conflicts. Using simple textarea.</p>
      </div>
      <div className="rich-editor-content-wrapper">
        <textarea
          value={content}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          style={{ width: '100%', height: '400px', padding: '10px', border: '1px solid #ccc' }}
        />
      </div>
    </div>
  );
};

export default RichEditor;